import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ProviderEmailModel from "../../models/provider-email";

export default class ProviderEmailRepository extends BaseRepository {
  static modelClass = ProviderEmailModel;
  modelName = "provider-email";

  async bulkCreate(data) {
    return await super.createBulk(data, {
      urlPath: "provider_email/bulk_create",
    });
  }

  async bulkUpdate(data) {
    return await super.createBulk(data, {
      urlPath: "provider_email/bulk_update",
    });
  }

  async bulkDelete(data) {
    return await super.createBulk(data, {
      urlPath: "provider_email/bulk_delete",
    });
  }
}
